module.exports = __webpack_public_path__ + "678be84bcaacc2ec49488ded46ed4284.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/DJ.svg
// module id = Dv3c
// module chunks = 0